import {CSSProperties, PropsWithChildren, useContext} from "react";
import classNames from "classnames";

import {CloseIcon} from "@pg-design/icons-module";
import {IModalCore, ModalCore} from "@pg-design/modal-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";

import {DrawerContext, DrawerContextProvider, IDrawerTheme, IDrawerVariant} from "./DrawerContext";

import * as styles from "./Drawer.module.css";

interface IDrawerProps extends Omit<IModalCore, "contentStyle" | "onModalClose"> {
    variant?: IDrawerVariant;
    systemTheme?: IDrawerTheme;
    zIndex?: number;
    onDrawerClose: IModalCore["onModalClose"];
    contentStyle?: CSSProperties;
}

export const Drawer = (props: PropsWithChildren<IDrawerProps>) => {
    const {children, systemTheme, contentStyle, zIndex = 9000, ...restProps} = props;

    const isDarkTheme = systemTheme === "dark";
    const variant = props.variant ? props.variant : "right";
    const contentClassNames = classNames(styles.contentBaseStyle, props.variant === "left" ? styles.contentBaseStyle__left : styles.contentBaseStyle__right);

    return (
        <DrawerContextProvider value={{variant, systemTheme: systemTheme ? systemTheme : "light"}}>
            <ModalCore
                closeButton={(closeDrawer) => (
                    <div onClick={closeDrawer} className={styles.closeButtonStyle}>
                        <CloseIcon fill={isDarkTheme ? "#fff" : getThemeVariable("colors.secondary")} className={styles.closeButtonIconStyle} />
                    </div>
                )}
                contentStyle={contentStyle}
                contentClassName={contentClassNames}
                overlayStyle={{zIndex}}
                overlayClassName={styles.overlayBaseStyle}
                onModalClose={props.onDrawerClose}
                {...restProps}
            >
                {children}
            </ModalCore>
        </DrawerContextProvider>
    );
};

Drawer.Header = (props: PropsWithChildren<{}>) => {
    const {children} = props;
    const {systemTheme} = useContext(DrawerContext);

    return (
        <div>
            <Text as="h3" variant="headline_4" color={systemTheme === "dark" ? "#fff" : getThemeVariable("colors.secondary")} className={styles.drawerHeader}>
                {children}
            </Text>
        </div>
    );
};

Drawer.Content = (
    props: PropsWithChildren<{
        className?: string;
    }>
) => {
    const {children, className} = props;
    const {systemTheme} = useContext(DrawerContext);

    const cn = classNames(styles.drawerContent, className);

    return (
        <Text as="div" variant="body_copy_2" color={systemTheme === "dark" ? "#fff" : getThemeVariable("colors.secondary")} className={cn}>
            {children}
        </Text>
    );
};
import {CSSProperties, PropsWithChildren, useContext} from "react";
import classNames from "classnames";

import {CloseIcon} from "@pg-design/icons-module";
import {IModalCore, ModalCore} from "@pg-design/modal-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";

import {DrawerContext, DrawerContextProvider, IDrawerTheme, IDrawerVariant} from "./DrawerContext";

import * as styles from "./Drawer.module.css";

interface IDrawerProps extends Omit<IModalCore, "contentStyle" | "onModalClose"> {
    variant?: IDrawerVariant;
    systemTheme?: IDrawerTheme;
    zIndex?: number;
    onDrawerClose: IModalCore["onModalClose"];
    contentStyle?: CSSProperties;
}

export const Drawer = (props: PropsWithChildren<IDrawerProps>) => {
    const {children, systemTheme, contentStyle, zIndex = 9000, ...restProps} = props;

    const isDarkTheme = systemTheme === "dark";
    const variant = props.variant ? props.variant : "right";
    const contentClassNames = classNames(styles.contentBaseStyle, props.variant === "left" ? styles.contentBaseStyle__left : styles.contentBaseStyle__right);

    return (
        <DrawerContextProvider value={{variant, systemTheme: systemTheme ? systemTheme : "light"}}>
            <ModalCore
                closeButton={(closeDrawer) => (
                    <div onClick={closeDrawer} className={styles.closeButtonStyle}>
                        <CloseIcon fill={isDarkTheme ? "#fff" : getThemeVariable("colors.secondary")} className={styles.closeButtonIconStyle} />
                    </div>
                )}
                contentStyle={contentStyle}
                contentClassName={contentClassNames}
                overlayStyle={{zIndex}}
                overlayClassName={styles.overlayBaseStyle}
                onModalClose={props.onDrawerClose}
                {...restProps}
            >
                {children}
            </ModalCore>
        </DrawerContextProvider>
    );
};

Drawer.Header = (props: PropsWithChildren<{}>) => {
    const {children} = props;
    const {systemTheme} = useContext(DrawerContext);

    return (
        <div>
            <Text as="h3" variant="headline_4" color={systemTheme === "dark" ? "#fff" : getThemeVariable("colors.secondary")} className={styles.drawerHeader}>
                {children}
            </Text>
        </div>
    );
};

Drawer.Content = (
    props: PropsWithChildren<{
        className?: string;
    }>
) => {
    const {children, className} = props;
    const {systemTheme} = useContext(DrawerContext);

    const cn = classNames(styles.drawerContent, className);

    return (
        <Text as="div" variant="body_copy_2" color={systemTheme === "dark" ? "#fff" : getThemeVariable("colors.secondary")} className={cn}>
            {children}
        </Text>
    );
};
